import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
export var Title = function(param) {
    var className = param.className, title = param.title, subtitle = param.subtitle, titleVariant = param.titleVariant, shouldHideTextTag = param.shouldHideTextTag;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        $useUpdatedSpacing: isLoggedInRetailer(),
        children: [
            typeof title === "string" ? /* For SEO purpose, we have to make this h1 tag, please don't change unless consulted with the SEO team */ /*#__PURE__*/ _jsx(Typography, {
                variant: titleVariant !== null && titleVariant !== void 0 ? titleVariant : "displaySSerifRegular",
                as: shouldHideTextTag ? undefined : "h1",
                "data-test-id": "catnav-title",
                children: title
            }) : title,
            typeof subtitle === "string" ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        as: shouldHideTextTag ? undefined : "h2",
                        "data-test-id": "catnav-subtitle",
                        children: subtitle
                    })
                ]
            }) : subtitle
        ]
    });
};
var Wrapper = styled(Column).attrs({
    align: "stretch"
}).withConfig({
    componentId: "sc-a0defdd4-0"
})([
    "align-self:stretch;padding:",
    ";"
], function(param) {
    var $useUpdatedSpacing = param.$useUpdatedSpacing;
    return $useUpdatedSpacing ? 0 : "0 0 2px";
});
